import React, { useState } from 'react';
import { X, Save } from 'lucide-react';

const OUTCOMES = [
  { value: 'spoke_to_contact', label: 'Spoke to Contact' },
  { value: 'no_answer', label: 'No Answer' },
  { value: 'voicemail', label: 'Left Voicemail' },
  { value: 'busy', label: 'Busy / Engaged' },
  { value: 'wrong_number', label: 'Wrong Number' },
];

const CallLogModal = ({ lead, onSave, onClose, saving }) => {
  const [outcome, setOutcome] = useState('spoke_to_contact');
  const [notes, setNotes] = useState('');

  if (!lead) return null;

  const handleSave = () => {
    onSave(lead.id, { call_outcome: outcome, notes: notes.trim() || null });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end sm:items-center justify-center" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="bg-white w-full sm:max-w-md sm:rounded-2xl rounded-t-2xl max-h-[85vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-bold text-gray-900">Log Call</h3>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100">
            <X size={20} />
          </button>
        </div>

        <div className="p-4 space-y-4">
          {/* Business name */}
          <div className="text-sm text-gray-600">
            <span className="font-semibold">{lead.business_name}</span>
          </div>

          {/* Outcome buttons */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Call Outcome</label>
            <div className="space-y-2">
              {OUTCOMES.map(o => (
                <button
                  key={o.value}
                  onClick={() => setOutcome(o.value)}
                  className={`w-full min-h-[44px] rounded-xl px-4 text-left font-medium transition-all
                    ${outcome === o.value
                      ? 'bg-blue-100 text-blue-800 ring-2 ring-blue-500'
                      : 'bg-gray-50 text-gray-700 active:bg-gray-100'
                    }`}
                >
                  {o.label}
                </button>
              ))}
            </div>
          </div>

          {/* Notes */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Notes</label>
            <textarea
              value={notes}
              onChange={e => setNotes(e.target.value)}
              placeholder="Brief call notes..."
              rows={3}
              className="w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-base p-3"
            />
          </div>

          {/* Save button */}
          <button
            onClick={handleSave}
            disabled={saving}
            className="w-full flex items-center justify-center gap-2 min-h-[52px] rounded-xl bg-green-600 active:bg-green-800 text-white font-bold text-base disabled:opacity-50 transition-all"
          >
            <Save size={20} />
            <span>{saving ? 'Saving...' : 'Save Call Log'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CallLogModal;
